import React from 'react';
import PropTypes from 'prop-types';
// import { autobind } from 'core-decorators';
import Link from './shared/Link';
import fabric from '../../../common/fabric';
import utils from '../../../common/utils';

/**
 * Path component
 *
 * @param props
 * @returns {XML}
 * @constructor
 */
const BrushPath = props => {
  // @autobind

  const [SVGRendered, setSVGRendered] = React.useState();
  const [options, setOptions] = React.useState();

  React.useEffect(() => {
    const { params, matrixGroup } = props;
    // Undefined mean it's not saved as it's a default so we must use 1.
    params.strokeWidth =
      params.strokeWidth === undefined ? 1 : params.strokeWidth;
    const object = new fabric.LudusBrushPath(params);

    const transformMatrix = matrixGroup
      ? fabric.util.multiplyTransformMatrices(
          matrixGroup,
          params.ludus.transformMatrix,
        )
      : params.ludus.transformMatrix;
    const _options = fabric.util.qrDecompose(transformMatrix);

    object.set({
      ..._options,
      opacity: 1,
      shadow: null,
    });

    if (object.fill && object.fill.colorStops && object.pathOffset) {
      // for some unknown reasons fabric is applying an offset on gradients based on pathOffset,
      // we have to cancel it somehow.
      // see gradient.class.js > toSVG() lines 237 in fabric source code
      object.fill.offsetX += object.pathOffset.x;
      object.fill.offsetY += object.pathOffset.y;
    }

    object.setPositionByOrigin(
      {
        x: _options.translateX,
        y: _options.translateY,
      },
      'left',
      'top',
    );

    const bounds = object.getBoundingRect(false, false);
    setOptions({
      ..._options,
      x: _options.translateX - bounds.width / 2,
      y: _options.translateY - bounds.height / 2,
    });

    object.setPositionByOrigin(
      {
        x: bounds.width / 2,
        y: bounds.height / 2,
      },
      'center',
      'center',
    );

    setSVGRendered(
      `<svg width="${bounds.width}" height="${
        bounds.height
      }" style="overflow: ${
        object.strokeWidth > 0 ? 'visible' : 'hidden'
      }"; fill="none" xmlns="http://www.w3.org/2000/svg">${object.toSVG()}</svg>`,
    );
    // this.setState({ svgRendered });
  }, [props.globalScale, props.params]);

  if (!SVGRendered) {
    return null;
  }
  const { params, style, hyperlink, groupOpacity } = props;
  const { shadow } = params;
  const shadowFilter = utils.getDropShadowCSSFilterFromFabricShadow(
    shadow,
    0,
    props.globalScale,
  );
  const blockStyles = {
    ...style,
    left: 0,
    top: 0,
    transformOrigin: 'left top',
    transform: `scale(${props.globalScale}) translate(${options.x}px, ${options.y}px)`,
    opacity: groupOpacity,
    mixBlendMode:
      params.globalCompositeOperation === 'source-over'
        ? 'normal'
        : params.globalCompositeOperation,
  };

  const shadowStyle = {
    filter: shadowFilter,
    // necessary for safari smoothness
    transform: shadow ? 'translateZ(0px)' : 'none',
  };

  return (
    <>
      {shadow ? (
        <div style={shadowStyle}>
          <Link
            hyperlink={hyperlink}
            style={blockStyles}
            dangerouslySetInnerHTML={{ __html: SVGRendered }}
          />
        </div>
      ) : (
        <Link
          hyperlink={hyperlink}
          style={blockStyles}
          dangerouslySetInnerHTML={{ __html: SVGRendered }}
        />
      )}
    </>
  );
};

BrushPath.propTypes = {
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  params: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.bool,
      PropTypes.func,
      PropTypes.number,
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  groupOpacity: PropTypes.number.isRequired,
  hyperlink: PropTypes.string,
  matrixGroup: PropTypes.arrayOf(PropTypes.number),
  globalScale: PropTypes.number,
};
BrushPath.defaultProps = {
  hyperlink: null,
  matrixGroup: null,
  globalScale: 1,
};

export default BrushPath;
